'use client'
import { DeviceType } from '@/app/util/env'
import { ReactNode, createContext, useContext } from 'react'

export type UAParserProps = {
    deviceType: DeviceType
    isBot: boolean
}

const UAParserContext = createContext({} as UAParserProps)

export const RenderProps = ({ children }: { children: (deviceType: DeviceType, isBot: boolean) => ReactNode }) => {
    const { deviceType, isBot } = useContext(UAParserContext)
    return children(deviceType, isBot)
}

export default UAParserContext
